import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./features/slices/rootSlice";
import notificationsSlice from "./features/slices/notificationsSlice";
import lockScreenReducer from "./features/slices/lockScreenSlice";
import RootPublicReducer from "./features/slices/rootPublicSlice";
import topMenuReducer from "./features/TopMenu/slice";
export const store = configureStore({
    reducer: {
        root: rootReducer,
        notifications: notificationsSlice,
        lockScreen: lockScreenReducer,
        rootPublicState: RootPublicReducer,
        topMenu: topMenuReducer,
    },
});
